import React, { useState,useEffect,useCallback } from "react";
import { connect } from "react-redux";
import { LoadPanel } from "devextreme-react/load-panel";
import { createStore } from 'devextreme-aspnet-data-nojquery';
import TextBox from "devextreme-react/text-box";
import Button from "devextreme-react/button";
import axios from "axios";
import DateBox from 'devextreme-react/date-box';
import { alert } from "devextreme/ui/dialog";
import DataSource from "devextreme/data/data_source";
import { SelectBox } from 'devextreme-react/select-box';

function QuickLotEntryScreen(props) {
    var accessToken = props.oidc.user.access_token;
    const [loadPanelVisible, setLoadPanelVisible] = useState(false);
    const initialFormFields = {
        ROWID: '00000000-0000-0000-0000-000000000000',
        KEYSEQUENCE: 1,
        CREATIONDATETIME: null,
        CREATIONUSERID: '',
        LASTUPDATEDATETIME: null,
        LASTUPDATEUSERID: '',
        COMPANYID: '',
        MODULE: 'WM',
        RECORDTYPE: 'R',
        R_ITEM: '',
        PROFILECODE: '',
        CUSTOMERCODE: '',
        LOTCODE: '',
        DESCRIPTION_1: '',
        DESCRIPTION_2: '',
        STATUS: 'A',
        COMMENT: '',
        R_VENDOR: '',
        ROUTECODE: '',
        R_LOCATION: '',
        LOTSIZECODE: '',
        LOTPROJECTIONCODE: '',
        LOTUNITUOMFLAG: '',
        LOTUOMDEFAULT: '',
        LOTUNITSPERITEMUNIT: null,
        ROYALTYFLAG: '',
        ROYALTYUNITCOST: null,
        ROYALTYUNITPRICE: null,
        ROYALTYADDTOPRICEFLAG: '',
        STAGEFLAG: '',
        REORDERINVENTORYMINIMUMQTY: null,
        REORDERINVENTORYMAXIMUMQTY: null,
        REORDERQUANTITYEOQCALCULATED: null,
        REORDERQUANTITYORDERMULTIPLE: null,
        REORDERSAFETYQUANTITY: null,
        REORDERLEADTIME: null,
        COSTBASISMETHODFLAG: '',
        AVERAGECOST: null,
        STANDARDCOST: null,
        R_PRICETABLE: '',
        COREPRICE: null,
        MAXIMUMPRICELEVELFORDISCOUNT: '',
        TRADEDISCOUNTONSPECIALPRICE_AR: '',
        EARLYPAYDISCOUNTFLAG: '',
        COSTALLOCATIONFACTOR: null,
        DATEINTRODUCED: new Date(),
        REORDERQUANTITYENTERED: null,
        DATEAVAILABLE: new Date(),
        REORDERMETHODFLAG: 'N',
        DATEEXPIRATION: null,
        REORDERMINIMUMDAYSONHAND: null,
        REORDERMAXIMUMDAYSONHAND: null,
        CLASSCODE: '',
        SUBCLASSCODE: '',
        R_PRODUCTCATEGORY: '',
        R_OEMMANUFACTUREID: '',
        OEMMANUFACTURERCODE: '',
        VENDORITEMCODE: '',
        PHYSICALCOUNTCODE: '',
        USERDEFINEDCODE_1: '',
        USERDEFINEDCODE_2: '',
        USERDEFINEDCODE_3: '',
        USERDEFINEDCODE_4: '',
        USERDEFINEDCODE_5: '',
        USERDEFINEDCODE_6: '',
        USERDEFINEDCODE_7: '',
        USERDEFINEDCODE_8: '',
        USERDEFINEDCODE_9: '',
        USERDEFINEDCODE_10: '',
        USERDEFINEDREFERENCE_1: '',
        USERDEFINEDREFERENCE_2: '',
        USERDEFINEDREFERENCE_3: '',
        USERDEFINEDREFERENCE_4: '',
        USERDEFINEDREFERENCE_5: '',
        USERDEFINEDREFERENCE_6: '',
        USERDEFINEDREFERENCE_7: '',
        USERDEFINEDREFERENCE_8: '',
        USERDEFINEDREFERENCE_9: '',
        USERDEFINEDREFERENCE_10: '',
        USERDEFINEDDATE_1: null,
        USERDEFINEDDATE_2: null,
        USERDEFINEDDATE_3: null,
        USERDEFINEDDATE_4: null,
        USERDEFINEDDATE_5: null,
        USERDEFINEDDATE_6: null,
        USERDEFINEDDATE_7: null,
        USERDEFINEDDATE_8: null,
        USERDEFINEDDATE_9: null,
        USERDEFINEDDATE_10: null,
        USERDEFINEDQUANTITY_1: null,
        USERDEFINEDQUANTITY_2: null,
        USERDEFINEDQUANTITY_3: null,
        USERDEFINEDQUANTITY_4: null,
        USERDEFINEDQUANTITY_5: null,
        USERDEFINEDQUANTITY_6: null,
        USERDEFINEDQUANTITY_7: null,
        USERDEFINEDQUANTITY_8: null,
        USERDEFINEDQUANTITY_9: null,
        USERDEFINEDQUANTITY_10: null,
        INVENTORYUNITUOM: '',
        PIECESPERUNITUOM: '',
        PIECESPERUNITQUANTITY: null,
        UNITSPERPACKAGEUOM: '',
        UNITSPERPACKAGEQUANTITY: null,
        PACKAGESPERSHIPPINGUNITUOM: '',
        PACKAGESPERSHIPPINGUNITQTY: null,
        UNITVOLUMEUOM: '',
        UNITVOLUMEQUANTITY: null,
        UNITAREAUOM: '',
        UNITAREAQUANTITY: null,
        UNITVALUEUOM: '',
        NETWEIGHTUOM: '',
        NETWEIGHTQUANTITY: null,
        GROSSWEIGHTUOM: '',
        UNITVALUEQUANTITY: null,
        GROSSWEIGHTQUANTITY: null,
        ON_HAND: 0,
        IN_ORDERED: 0,
        OUT_ORDERED: 0,
        IN_RECEIVING: 0,
        OUT_SHIPPED: 0,
        IN_BACKORDER: 0,
        OUT_BACKORDER: 0,
        IN_UNAVAILABLE: 0,
        OUT_UNAVAILABLE: 0,
        IN_FUTURE: 0,
        OUT_FUTURE: 0,
        AVAILABLE: 0,
        NETAVAILABLE: 0,
        STORAGEBILLINGSTARTDATE: new Date(),
        STORAGEBILLINGENDDATE: new Date(2999, 11, 31),
        R_RATESCHEDULE: '',
        POPUPMESSAGE: '',
        LASTCOST: null,
        SIZE_1: null,
        R_BUYER: '',
        SIZE_2: null,
        STORAGEBILLEDDATE_LAST: null,
        STORAGEBILLEDDATE_NEXT: null,
        PRICESOURCE: '',
        PRICEMETHOD: '',
        CALCMETHOD: '',
        PRICELEVELA: null,
        PRICELEVELB: null,
        PRICELEVELC: null,
        PRICELEVELD: null,
        PRICELEVELE: null,
        R_GLDEPARTMENT: '',
        R_GLFUND: '',
        R_CAJOB: '',
        PRICEBASIS: null,
        R_FEES: '',
        ITEMSUPCCODE: '',
        RFRECEIPTVALIDATION: 'N',
        RFSHIPMENTVALIDATION: 'N',
        INTRANSACTIONNUMBER: '',
        DATELASTRECEIPT: null,
        R_PARTICIPANT: '',
        COMMISSIONBASIS: '',
        COMMISSIONAMOUNT: null,
        ROUNDINGMETHOD: '',
        ROUNDINGFACTOR: null,
        ALTERNATESTANDARDCOST: null,
        ALTERNATEAVERAGECOST: null,
        ALTERNATELASTCOST: null,
        PREVSTORAGEBILLEDDATE_LAST: null,
        PREVSTORAGEBILLEDDATE_NEXT: null,
        RECURRINGSTORAGE: 'Y',
        PROGRESSIVECURRENTRATE: null,
        PROGRESSIVELASTRATE: null,
        PROGRESSIVEPREVIOUSLASTRATE: null,
        PROGRESSIVEBILLINGCOUNT: null,
        R_LOT_SOURCE: '',
        OVERSELLPERCENTAGE: null,
        RECORD: '',
        INVENTORYUNITNOTUSED: 1,
        GROSSMINUSNET: null,
        ITEMRATESOURCE: ''
    };
    const [formFields, setformFields] = useState(initialFormFields);
    const position = { of: "#accordion-containe2" };
    const [dateWorkUnitData, setDateSourceWorkUnitData] = useState(null);
    const [classCodeData, setClassCodeData] = useState(null);
    const [subclassCodeData, setSubClassCodeData] = useState(null);
    const loadclassCodeData = useCallback(() => {
        const classCodeData = new DataSource({
            store: new createStore({
                key: 'name',
                loadUrl: `${window._env_.REACT_APP_APIS}/wm/Lookup/GetCodes`,
                loadParams: {
                    codeType: function () {
                      return "28";
                    }
                  },
                onBeforeSend: function (method, ajaxOptions) {
                    ajaxOptions.headers = {
                        Authorization: `Bearer ${accessToken}`,
                    };
                }
            }),
            paginate: true,
            pageSize: 100,
            sort: [
                {
                  selector: "name",
                  desc: false,
                }
              ],
        });
        setClassCodeData(classCodeData);
    }, []);
    const loadsubclassCodeData = useCallback(() => {
        const subclassCodeData = new DataSource({
            store: new createStore({
                key: 'name',
                loadUrl: `${window._env_.REACT_APP_APIS}/wm/Lookup/GetCodes`,
                loadParams: {
                    codeType: function () {
                      return "29";
                    }
                  },
                onBeforeSend: function (method, ajaxOptions) {
                    ajaxOptions.headers = {
                        Authorization: `Bearer ${accessToken}`,
                    };
                }
            }),
            paginate: true,
            pageSize: 100,
            sort: [
                {
                  selector: "name",
                  desc: false,
                }
              ],
        });
        setSubClassCodeData(subclassCodeData);
    }, []);
    const loadworkUnitData = useCallback(() => {
        const workUnitData = new DataSource({
            store: new createStore({
                key: 'name',
                loadUrl: `${window._env_.REACT_APP_APIS}/ed/Lookup/GetEdelementcodese`,
                loadParams: {
                    dataelementnum: () => '355',
                    versionid: () => '4010',
                },
                onBeforeSend: function (method, ajaxOptions) {
                    ajaxOptions.headers = {
                        Authorization: `Bearer ${accessToken}`,
                    };
                }
            }),
            paginate: true,
            pageSize: 100,
            // Sorting is applied after data load
            reshapeOnPush: true,
            postProcess: function (data) {
                return data.sort((a, b) => {
                    const isAlphaA = /^[A-Za-z]/.test(a.name);
                    const isAlphaB = /^[A-Za-z]/.test(b.name);
                    if (isAlphaA && !isAlphaB) return -1;
                    if (!isAlphaA && isAlphaB) return 1;
                    return a.name.localeCompare(b.name, undefined, { numeric: true, sensitivity: 'base' });
                });
            }
        });
        setDateSourceWorkUnitData(workUnitData);
    }, []);
    const handleSubmit = async () => {
        console.log("Submitting form data:", formFields);
        setLoadPanelVisible(true);
        try {
            var res = await axios.post
                (
                    `${window._env_.REACT_APP_APIS}/wm/Lot/UpdateLotInfo`,
                    formFields,
                    {
                        headers: {
                            "Content-Type": "application/json",
                            access_token: accessToken,
                        },
                    }
                );
        } catch (error) {
            console.error('Error submitting form:', error);
        } finally {
            setTimeout(hideLoadPanel, 1000);
            props.setShowQuickLotEntryScreen({isVisible:false});

        }
    };
    const GetHeaderInfoById = (id) => {
        try {
            setLoadPanelVisible(true);
            axios.get(`${window._env_.REACT_APP_APIS}/wm/lot/GetLotDataByRowId?rowid=${id}`, {
                headers: {
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`
                }
            }).then((res) => {
                const responseData = res.data.Item1;
                console.log("Parsed Item1:", JSON.stringify(responseData, null, 2));
                if (responseData && responseData.ROWID) {
                    setformFields(responseData);
                }
                else {
                    console.error('Failed to get lot data');
                }
            });
        } catch (error) {
            console.error('Error failed to get lot data:', error);
        } finally {
            setTimeout(hideLoadPanel, 1000);
        }
    };

    const handleFieldChange = (fieldName) => (e) => {
        setformFields(prev => ({
            ...prev,
            [fieldName]: e.value
        }));
    };
    const hideLoadPanel = useCallback(() => {
        setLoadPanelVisible(false);
    }, [setLoadPanelVisible]);
    useEffect(() => {
        loadworkUnitData();
        loadclassCodeData();
        loadsubclassCodeData();
        GetHeaderInfoById(props.showQuickLotEntryScreen.insertedLotId);
        
      }, []);
    return (
        <div className="FormMt container-fluid" style={{ paddingTop: "0px" }}>
            <LoadPanel
                shadingColor="rgba(0,0,0,0.4)"
                position={position}
                onHiding={() => setLoadPanelVisible(false)}
                visible={loadPanelVisible}
                showIndicator={true}
                shading={true}
                showPane={true}
                hideOnOutsideClick={false}
            />

            {/* Top section */}
            <div className="row">
                <div className="col-md-3">
                    <TextBox
                        labelMode='static'
                        label='Record #'
                        stylingMode='outlined'
                        value={formFields.RECORD}
                        disabled={true}
                    />
                </div>
                <div className="col-md-3">
                    <TextBox
                        labelMode="static"
                        label="Item"
                        stylingMode="outlined"
                        value={props.showQuickLotEntryScreen.itemCode}
                        disabled={true}
                    />
                </div>

                <div className="col-md-3">
                    <TextBox
                        labelMode="static"
                        label="Lot"
                        stylingMode="outlined"
                        value={formFields.LOTCODE}
                        onValueChanged={handleFieldChange('LOTCODE')}
                    />
                </div>

                <div className="col-md-3">
                    <TextBox
                        labelMode="static"
                        label="Description - 1"
                        stylingMode="outlined"
                        value={formFields.DESCRIPTION_1}
                        onValueChanged={handleFieldChange('DESCRIPTION_1')}
                    />
                </div>

            </div>
            <div className="row accordianLastRow">
                <div className="col-md-3">
                    <TextBox
                        labelMode="static"
                        label="Description - 2"
                        stylingMode="outlined"
                        value={formFields.DESCRIPTION_2}
                        onValueChanged={handleFieldChange('DESCRIPTION_2')}
                    />
                </div>

                <div className="col-md-3">
                     <SelectBox
                        dataSource={classCodeData}
                        value={formFields.CLASSCODE}
                        searchEnabled={true}
                        searchMode="contains"
                        onValueChanged={handleFieldChange('CLASSCODE')}
                        label="Class"
                        labelMode='static'
                        stylingMode='outlined'
                        displayExpr="name"
                        valueExpr="name"
                    >
                    </SelectBox>
                </div>

                <div className="col-md-3">
                    <SelectBox
                        dataSource={subclassCodeData}
                        value={formFields.SUBCLASSCODE}
                        searchEnabled={true}
                        searchMode="contains"
                        onValueChanged={handleFieldChange('SUBCLASSCODE')}
                        label="SubClass"
                        labelMode='static'
                        stylingMode='outlined'
                        displayExpr="name"
                        valueExpr="name"
                    >
                    </SelectBox>
                </div>

                <div className="col-md-3">
                    <DateBox
                        stylingMode="outlined"
                        labelMode="static"
                        label="Introduced Dt"
                        type="date"
                        value={formFields.DATEINTRODUCED}
                        onValueChanged={handleFieldChange('DATEINTRODUCED')}
                    />
                </div>

            </div>
            <div className="row accordianLastRow">
                <div className="col-md-3">
                    <DateBox
                        stylingMode="outlined"
                        labelMode="static"
                        label="Available Dt"
                        type="date"
                        value={formFields.DATEAVAILABLE}
                        onValueChanged={handleFieldChange('DATEAVAILABLE')}
                    />
                </div>

                <div className="col-md-3">
                    <DateBox
                        stylingMode="outlined"
                        labelMode="static"
                        label="Expiration Dt"
                        type="date"
                        value={formFields.DATEEXPIRATION}
                        onValueChanged={handleFieldChange('DATEEXPIRATION')}
                    />
                </div>

            </div>
            <div className="row accordianLastRow">
                <div className="col-md-3">
                    <TextBox
                        label="Quantity Factor Inventory"
                        labelMode="static"
                        stylingMode="outlined"
                        value={1}
                        disabled={true}
                    />
                </div>

                <div className="col-md-3">
                    <SelectBox
                        dataSource={dateWorkUnitData}
                        value={formFields.INVENTORYUNITUOM}
                        searchEnabled={true}
                        searchMode="contains"
                        onValueChanged={handleFieldChange('INVENTORYUNITUOM')}
                        label="UOM Inventory"
                        labelMode='static'
                        stylingMode='outlined'
                        displayExpr="name"
                        valueExpr="name"
                    >
                    </SelectBox>
                </div>

                <div className="col-md-3">
                    <TextBox
                        label="Quantity Factor Pieces"
                        labelMode="static"
                        stylingMode="outlined"
                        value={formFields.PIECESPERUNITQUANTITY}
                        onValueChanged={handleFieldChange('PIECESPERUNITQUANTITY')}
                    />
                </div>
                <div className="col-md-3">
                     <SelectBox
                        dataSource={dateWorkUnitData}
                        value={formFields.PIECESPERUNITUOM}
                        searchEnabled={true}
                        searchMode="contains"
                        onValueChanged={handleFieldChange('PIECESPERUNITUOM')}
                        label="UOM Pieces"
                        labelMode='static'
                        stylingMode='outlined'
                        displayExpr="name"
                        valueExpr="name"
                    >
                    </SelectBox>
                </div>
            </div>

            {/* Row 2 */}
            <div className="row accordianLastRow">
                <div className="col-md-3">
                    <TextBox
                        label="Quantity Factor Units/Pkg"
                        labelMode="static"
                        stylingMode="outlined"
                        value={formFields.UNITSPERPACKAGEQUANTITY}
                        onValueChanged={handleFieldChange('UNITSPERPACKAGEQUANTITY')}
                    />
                </div>
                <div className="col-md-3">
                      <SelectBox
                        dataSource={dateWorkUnitData}
                        value={formFields.UNITSPERPACKAGEUOM}
                        searchEnabled={true}
                        searchMode="contains"
                        onValueChanged={handleFieldChange('UNITSPERPACKAGEUOM')}
                        label="UOM Units/Pkg"
                        labelMode='static'
                        stylingMode='outlined'
                        displayExpr="name"
                        valueExpr="name"
                    >
                    </SelectBox>
                </div>
                <div className="col-md-3">
                    <TextBox
                        label="Quantity Factor Pkg/Ship"
                        labelMode="static"
                        stylingMode="outlined"
                        value={formFields.PACKAGESPERSHIPPINGUNITQTY}
                        onValueChanged={handleFieldChange('PACKAGESPERSHIPPINGUNITQTY')}
                    />
                </div>
                <div className="col-md-3">
                     <SelectBox
                        dataSource={dateWorkUnitData}
                        value={formFields.PACKAGESPERSHIPPINGUNITUOM}
                        searchEnabled={true}
                        searchMode="contains"
                        onValueChanged={handleFieldChange('PACKAGESPERSHIPPINGUNITUOM')}
                        label="UOM Pkg/Ship"
                        labelMode='static'
                        stylingMode='outlined'
                        displayExpr="name"
                        valueExpr="name"
                    >
                    </SelectBox>
                </div>
            </div>
            {/* Row 3 */}
            <div className="row accordianLastRow">
                <div className="col-md-3">
                    <TextBox
                        label="Quantity Factor Unit Volume"
                        labelMode="static"
                        stylingMode="outlined"
                        value={formFields.UNITVOLUMEQUANTITY}
                        onValueChanged={handleFieldChange('UNITVOLUMEQUANTITY')}
                    />
                </div>
                <div className="col-md-3">
                     <SelectBox
                        dataSource={dateWorkUnitData}
                        value={formFields.UNITVOLUMEUOM}
                        searchEnabled={true}
                        searchMode="contains"
                        onValueChanged={handleFieldChange('UNITVOLUMEUOM')}
                        label="UOM Unit Volume"
                        labelMode='static'
                        stylingMode='outlined'
                        displayExpr="name"
                        valueExpr="name"
                    >
                    </SelectBox>
                </div>
                <div className="col-md-3">
                    <TextBox
                        label="Quantity Factor Unit Area"
                        labelMode="static"
                        stylingMode="outlined"
                        value={formFields.UNITAREAQUANTITY}
                        onValueChanged={handleFieldChange('UNITAREAQUANTITY')}
                    />
                </div>
                <div className="col-md-3">
                     <SelectBox
                        dataSource={dateWorkUnitData}
                        value={formFields.UNITAREAUOM}
                        searchEnabled={true}
                        searchMode="contains"
                        onValueChanged={handleFieldChange('UNITAREAUOM')}
                        label="UOM Unit Area"
                        labelMode='static'
                        stylingMode='outlined'
                        displayExpr="name"
                        valueExpr="name"
                    >
                    </SelectBox>
                </div>

            </div>

            {/* Row 4 */}
            <div className="row accordianLastRow">
                <div className="col-md-3">
                    <TextBox
                        label="Quantity Factor Unit Value"
                        labelMode="static"
                        stylingMode="outlined"
                        value={formFields.UNITVALUEQUANTITY}
                        onValueChanged={handleFieldChange('UNITVALUEQUANTITY')}
                    />
                </div>
                <div className="col-md-3">
                     <SelectBox
                        dataSource={dateWorkUnitData}
                        value={formFields.UNITVALUEUOM}
                        searchEnabled={true}
                        searchMode="contains"
                        onValueChanged={handleFieldChange('UNITVALUEUOM')}
                        label="UOM Unit Value"
                        labelMode='static'
                        stylingMode='outlined'
                        displayExpr="name"
                        valueExpr="name"
                    >
                    </SelectBox>
                </div>
                <div className="col-md-3">
                    <TextBox
                        label="Quantity Factor Net Weight"
                        labelMode="static"
                        stylingMode="outlined"
                        value={formFields.NETWEIGHTQUANTITY}
                        onValueChanged={handleFieldChange('NETWEIGHTQUANTITY')}
                    />
                </div>
                <div className="col-md-3">
                    <SelectBox
                        dataSource={dateWorkUnitData}
                        value={formFields.NETWEIGHTUOM}
                        searchEnabled={true}
                        searchMode="contains"
                        onValueChanged={handleFieldChange('NETWEIGHTUOM')}
                        label="UOM Net Weight"
                        labelMode='static'
                        stylingMode='outlined'
                        displayExpr="name"
                        valueExpr="name"
                    >
                    </SelectBox>
                </div>

            </div>

            {/* Row 5 */}
            <div className="row accordianLastRow">
                <div className="col-md-3">
                    <TextBox
                        label="Quantity Factor Tare/Package"
                        labelMode="static"
                        stylingMode="outlined"
                        value={formFields.GROSSWEIGHTQUANTITY - formFields.NETWEIGHTQUANTITY}
                        disabled={true}
                   />
                </div>
                <div className="col-md-3">
                    <TextBox
                        label="UOM Tare/Package"
                        labelMode="static"
                        stylingMode="outlined"
                        value={formFields.NETWEIGHTUOM}
                        disabled={true}
                    />
                </div>
                <div className="col-md-3">
                    <TextBox
                        label="Quantity Factor Gross Weight"
                        labelMode="static"
                        stylingMode="outlined"
                        value={formFields.GROSSWEIGHTQUANTITY}
                        onValueChanged={handleFieldChange('GROSSWEIGHTQUANTITY')}
                    />
                </div>
                <div className="col-md-3">
                    <TextBox
                        label="UOM Gross Weight"
                        labelMode="static"
                        stylingMode="outlined"
                        value={formFields.NETWEIGHTUOM}
                        disabled={true}
                    />
                </div>
            </div>
            {/* Submit Button */}
            <div className="row accordianLastRow">
                <div className="col-md-12 text-right">
                    <Button text="Submit" type="default" onClick={handleSubmit} />
                </div>
            </div>
        </div>
    );
}

function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}

export default connect(mapStateToProps)(QuickLotEntryScreen);
